import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, message, Row, Space } from 'antd'
import { menuStockMovementType, StockMovementChannel, StockMovementType } from 'helpers/constanst'
import {
  currentDateTimeThaiformat,
  formatDateTime,
  getGrnStatus,
  getOrderStatus,
  getRequestString,
  getReturnOrderStatus,
  getStockMovementChannel,
  getStockMovementType,
  getSupplierOrderStatus,
  mapWordingStockMovementReport,
  numberWithComma,
  toDateQuery,
} from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { appConfig } from 'config'
import StockLogsDrawer from './StockLogsDrawer'
import { StockListData, StockMovementData, StockMoveMentReq } from 'Store/stock/types'
import { RangeDateItem, SelectItem } from 'Components/form'
import { PrimaryButton } from 'Components/button'
import { DownloadOutlined } from '@ant-design/icons'
import Axios from 'axios'
import downloadCSVFile from 'helpers/export'
import { TableListPage } from 'Components/common/Table'
import { Pagination } from 'Components/Pagination'
import { selectStockMovementEvent, selectStockMovementList } from 'Store/stock/selector'
import { getStockMovementListAPI } from 'Store/stock/api'
import { APIPath } from 'services/APIPath'
import { StatusTag } from 'Components/utilities'
import { cloneDeep } from 'lodash'
import ProductInfo from './ProductInfo'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
  stockData?: StockListData
}

const StockMovement: React.FunctionComponent<Props> = props => {
  const initFilter = {
    start_date: '',
    end_date: '',
    tran_type: '',
  }

  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const { onCloseDrawer, visible, onSuccess = () => {}, stockData, currentUser, list, listEvent, id } = props
  const dispatch = useDispatch()

  const meta = list?.meta
  const datas = list?.data

  const [showLogDrawer, setShowLogDrawer] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [visible])

  const onGetList = (): void => {
    const req: StockMoveMentReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      product_option_id: stockData?.product_option_id || 0,
      tran_type: filter.tran_type,
      sort_date: 'desc',
    }
    dispatch(getStockMovementListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (visible && currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  useEffect(() => {
    if (visible && currentUser?.accessToken) {
      onGetList()
    }

    return () => {
      setFilter(cloneDeep(initFilter))
    }
  }, [visible])

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onExport = (): void => {
    setExporting(true)
    const req: StockMoveMentReq = {
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      product_option_id: stockData?.product_option_id || 0,
      tran_type: filter.tran_type,
      sort_date: 'desc',
      export: true,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.stockMovementReport}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.uuid || '',
        'x-auth-mid': currentUser?.activeMerchant?.id || 0,
      },
    }
    Axios.get(endPoint, header)
      .then((res: any) => {
        const reportData = mapWordingStockMovementReport(res.data)
        const fileName = `รายงานการเคลื่อนไหวคลังสินค้า ${
          stockData?.product_title
        }ประจำวันที่ ${currentDateTimeThaiformat()}`
        downloadCSVFile(reportData, fileName)
        setExporting(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const title = (
    <Space>
      <span>การเคลื่อนไหวคลังสินค้า</span>
    </Space>
  )

  const renderType = (val: string) => {
    const result = getStockMovementType(val)
    return <StatusTag color={result.color} isPass={false} text={result.text} />
  }

  const renderStatus = (status: string, record: StockMovementData) => {
    let result = {
      text: 'สำเร็จ',
      color: 'green',
    } as any
    if (record.tran_type === StockMovementType.SALE) {
      if (record.channel === StockMovementChannel.SUPPLIER) {
        result = getSupplierOrderStatus(status)
      } else {
        result = getOrderStatus(status)
      }
    }
    if (record.tran_type === StockMovementType.RECEIPT) {
      result = getGrnStatus(status)
    }

    if (record.tran_type === StockMovementType.VOID) {
      result = getReturnOrderStatus(status)
    }

    return <StatusTag color={result?.color} isPass={true} text={result?.text} />
  }

  const columns = [
    {
      title: 'วันที่',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => formatDateTime(val),
    },
    {
      title: 'ประเภท',
      dataIndex: 'tran_type',
      key: 'tran_type',
      render: (val: string) => renderType(val),
    },
    {
      title: 'ช่องทาง',
      dataIndex: 'channel',
      key: 'channel',
      render: (val: string) => getStockMovementChannel(val).text || '-',
    },
    {
      title: `จำนวน (${stockData?.uom})`,
      dataIndex: 'quantity',
      key: 'quantity',
      render: (val: number) => numberWithComma(val),
      align: 'right',
    },
    {
      title: '',
      dataIndex: '',
      key: 'space',
      width: '50px',
    },
    {
      title: 'หมายเลขอ้างอิง',
      dataIndex: 'tran_ref',
      key: 'tran_ref',
    },
    {
      title: 'สถานะ',
      dataIndex: 'tran_status',
      key: 'tran_status',
      render: renderStatus,
    },
  ]

  const LogsDrawer = (
    <StockLogsDrawer
      isShow={showLogDrawer}
      onClose={() => setShowLogDrawer(false)}
      product_id={stockData?.product_id || 0}
      product_option_id={stockData?.product_option_id || 0}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="middle" gutter={[8, 8]}>
        <Col xs={24} md={24}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={7}>
              <RangeDateItem
                placeHolder={['วันที่เริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col xs={24} md={7}>
              <SelectItem
                name={'tran_type'}
                label={''}
                isRequired={true}
                value={filter.tran_type}
                menu={menuStockMovementType}
                placeHolder={'ประเภท'}
                onChange={(val: string): any => onFilter('tran_type', val)}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
            <Col>
              <PrimaryButton
                icon={<DownloadOutlined />}
                text="รายงานการเคลื่อนไหวคลังสินค้า"
                btnType="Primary"
                onClick={onExport}
                loading={exporting}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <DetailDrawer title={title} onCloseDrawer={onCloseDrawer} visible={visible} footer={null} width={'80%'}>
      {LogsDrawer}
      <Row justify="space-between" gutter={[16, 32]}>
        <Col md={24} xs={24}>
          <ProductInfo stockData={stockData} />
        </Col>
        <Col span={24}>{FilterContent}</Col>
        <Col span={24}>
          <TableListPage
            columns={columns}
            datas={datas || []}
            isLoading={listEvent.IsLoading}
            paginationContent={PaginationContent}
            bordered={false}
            rowKey="id"
          />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectStockMovementList(state),
    listEvent: selectStockMovementEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(StockMovement)
